import React from 'react';
import { Link } from 'react-router-dom';
import { LuCar, LuPalette, LuLifeBuoy, LuUserRound, LuChevronRight } from 'react-icons/lu';
import Page from '../../components/ui/Page/Page';
import PageHeader from '../../components/ui/PageHeader/PageHeader';
import Card from '../../components/ui/Card/Card';
import './SettingsPage.less';

const SETTINGS = [
  { key: 'profile',    to: '/profile',              icon: LuUserRound, title: 'Profile',    desc: 'Your name and contact details.' },
  { key: 'vehicles',   to: '/vehicles',             icon: LuCar,       title: 'Vehicles',   desc: 'Manage saved vehicles and PINs.' },
  { key: 'appearance', to: '/settings/appearance',  icon: LuPalette,   title: 'Appearance', desc: 'Light, dark or system theme.' },
  { key: 'support',    to: '/support',              icon: LuLifeBuoy,  title: 'Support',    desc: 'Get help or report an issue.' },
];

function SettingsPage() {
  return (
    <Page>
      <PageHeader title="Settings" subtitle="Preferences for GreenCharge on this device." />
      <div className="gc-settings-list">
        {SETTINGS.map(({ key, to, icon: Icon, title, desc }) => (
          <Card key={key} as={Link} to={to} interactive className="gc-settings-row">
            <span className="gc-settings-icon" aria-hidden="true"><Icon /></span>
            <div className="gc-settings-text">
              <h3>{title}</h3>
              <p>{desc}</p>
            </div>
            <LuChevronRight className="gc-settings-chevron" aria-hidden="true" />
          </Card>
        ))}
      </div>
    </Page>
  );
}

export default SettingsPage;
